import * as angular from "angular";
import * as _ from "lodash";
import {ILogService, IPromise} from "angular";
import {IamUserEntity} from "../../iam/models/iam-user.model";
import {CommonsService} from "../../commons/services/commons-service.service";
import {ContactPersonModel} from "../../commons/models/contact-person.model";

export class AdminDialogService {

  /* @ngInject */
  constructor(private $mdDialog,
              private commonsService: CommonsService,
              private $log: ILogService,
              private IAMPermissions) {

  }

  editUser(event, user: IamUserEntity) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/edit-user-dialog.html').default,
      controller: function ($scope) {

        $scope.loading = false;
        $scope.user = angular.copy(user);
        $scope.removeExpiration = false;

        $scope.isResetExpirationDuration = false;

        $scope.isSuperOwner = self.IAMPermissions.hasRole('super.owner');

        $scope.cancel = self.$mdDialog.cancel;

        // ******************************
        // External methods
        // ******************************

        $scope.onToggleResetDuration = () => {
          $scope.isResetExpirationDuration = true;
          $scope.expirationDays = 1;
        }

        $scope.onChangeUserExpirationDays = (expirationDays: number) => {
          $scope.expirationDays = expirationDays;
        }

        $scope.onTogglePermanentUser = () => {
          $scope.removeExpiration = true;
          $scope.expirationDays = undefined;
        }

        $scope.onToggleTemporaryUser = () => {
          $scope.removeExpiration = false;
          $scope.expirationDays = 1;
        }

        $scope.onChangeTimezone = (zoneId) => {
          $scope.user.zoneId = zoneId;
        }

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide({user: $scope.user, expirationDays: $scope.expirationDays, removeExpiration: $scope.removeExpiration})

            }
          } else {
            self.$log.error('Form resolved to undefined!. \n' +
              '--> adminDialogService@createNewAdmin  @submit')
          }

        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

  editPassword(event, user: IamUserEntity, passwordPolicy: any): IPromise<IamUserEntity> {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      // template: require('./../../user/dialog-views/edit-user-password-dialog.html').default,
      template: require('./../../commons/views/tmpl/edit-password-dialog.tmpl.html').default,
      controller: function ($scope) {

        $scope.user = angular.copy(user);
        $scope.passwordPolicy = passwordPolicy;
        $scope.verifyPassword = undefined;
        $scope.isShowPassword = false;

        $scope.zxExtras = user.email ?
          self.commonsService.buildZxExtras(user.email) :
          [];

        $scope.cancel = self.$mdDialog.cancel;

        // ******************************
        // External methods
        // ******************************

        $scope.onChangePassword = (password) => {
          $scope.user.password = password;
        }

        $scope.onVerifyPasswordChange = (form) => {
          form['verifyPassword'].$setValidity('mismatch', _.isEqual($scope.user.password, $scope.verifyPassword));
        }

        $scope.onUpdate = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide($scope.user)

            }
          } else {
            self.$log.error('Form resolved to undefined!. \n' +
              '--> adminDialogService@createNewAdmin  @submit')
          }

        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

  editSelfProfile(event, user: IamUserEntity) {
    const outer = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/edit-self-profile-dialog.html').default,
      controller: function ($scope) {

        $scope.loading = false;
        $scope.user = angular.copy(user);

        $scope.cancel = outer.$mdDialog.cancel;

        // ******************************
        // External methods
        // ******************************

        $scope.onChangeTimezone = (zoneId) => {
          $scope.user.zoneId = zoneId;
        }

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              outer.$mdDialog.hide($scope.user)
            }
          } else {
            outer.$log.error('Form resolved to undefined!. \n' +
              '--> adminDialogService@editSelfProfile  @submit')
          }
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

  editContactPerson(contactPerson: ContactPersonModel, branchId?: string, excludeBranchIds?: string[], event?): IPromise<{ contact: ContactPersonModel, branchId: string }> {
    const outer = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/edit-contact-person-dialog.html').default,
      controller: function ($scope) {

        $scope.isEdit = !!branchId;
        $scope.contact = contactPerson ? angular.copy(contactPerson) : {};
        $scope.branchId = branchId;
        $scope.excludeBranchIds = excludeBranchIds || [];

        $scope.cancel = outer.$mdDialog.cancel;

        // ******************************
        // External methods
        // ******************************

        $scope.onFieldChange = () => {
        }

        $scope.onBranchIdChange = (id) => {
          $scope.branchId = id;
        }

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              outer.$mdDialog.hide({contact: $scope.contact, branchId: $scope.branchId})
            }
          } else {
            outer.$log.error('Form resolved to undefined!. \n' +
              '--> adminDialogService@editContactPerson  @submit')
          }
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

}

angular
  .module('bringoz.admin.admins')
  .service('adminDialogService', AdminDialogService);
